import React from 'react';
import FilterState from './filter-state';
import GTMDataLayer from './gtm';

const ParagraphFilters = (props) => {

  const handleStateFilter = (e) => {
    if (e.target.value) {
      props.setFilters({...props.filters, state: e.target.value});
    }
      
    // Track paragraph state changes.
    GTMDataLayer({
      event: 'incentives_paragraph_filter_state',
      pageUrl: location.href,
      filter_state: e.target.value
    });
  };

  return (
    <div>
      {(props.dataFilters && Object.entries(props.dataFilters.state).length > 0) && (
        <div className='filter-states'>
          <FilterState states={props.dataFilters.state} selected={props.filters.state} handleStateFilter={handleStateFilter} />
        </div>
      )}
    </div>
  );
};

export default ParagraphFilters;